import React from 'react';

const ContactLink = () => (
  <p
    style={{
      marginTop: '2rem',
      cursor: 'pointer',
      color: '#000000',
    }}
  >
    Have more questions?{' '}
    <a
      href="https://pitstopconnect.com/book-a-demo/"
      target="_blank"
      rel="noopener noreferrer"
      style={{ fontWeight: 600, color: '#000000' }}
    >
      Get in touch with our team
    </a>
  </p>
);

export default ContactLink;
